"use client";

import Image from "next/image";
import PreviewTheme from "../../components/landingPage/home/PreviewTheme";
import { HomeCTAButton } from "@/components/landingPage/button/CTAButton";
import NewFeature from "@/components/landingPage/home/NewFeature";
import PackagePrice from "@/components/landingPage/home/PackagePrice";
import NewFAQ from "@/components/landingPage/home/NewFAQ";

import { useLocale } from "@/context/LocaleContext";
import FeatureTabs from "@/components/landingPage/home/FeatureTabs";
import ComparisonTable from "@/components/landingPage/home/ComparasionTable";

export default function Home() {
  const { t } = useLocale();

  return (
    <main className="bg-gray-50 overflow-hidden min-h-screen font-sans">
      <section className="pt-10 pb-16 md:pt-40 md:pb-24 md:mt-0 mt-20 px-5 md:px-8 xl:px-0 relative">
        <div className="container mx-auto max-w-7xl">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-4 items-center">

            {/* 1. KOLOM TEKS & TOMBOL */}
            <div className="lg:col-span-7 flex flex-col justify-center space-y-6 text-center lg:text-left z-10 md:-mt-20">
              <h1 className="text-[2.3rem] md:text-[3.5rem] lg:text-[52px] font-semibold text-[#2A2A2A] leading-[1.2] tracking-tight whitespace-pre-line">
                {t("LandingPage.hero_title")}
              </h1>

              <p className="text-[1.1rem] md:text-lg text-gray-700 leading-relaxed max-w-[95%] mx-auto lg:mx-0 font-normal">
                {t("LandingPage.hero_desc")}
              </p>

              {/* Tombol Desktop */}
              <div className="hidden lg:flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start pt-4">
                <HomeCTAButton className="!h-[55px] md:!h-[60px] !px-8 w-full sm:w-auto text-[1.1rem] !font-bold shadow-[0_8px_20px_rgba(232,92,87,0.3)] hover:shadow-[0_12px_25px_rgba(232,92,87,0.4)] transition-all" />
              </div>

              <div className="flex lg:hidden flex-col sm:flex-row items-center gap-4 justify-center pt-2 w-full">
                <HomeCTAButton className="!h-[55px] md:!h-[60px] !px-8 w-full sm:w-auto text-[1.1rem] !font-bold shadow-[0_8px_20px_rgba(232,92,87,0.3)] hover:shadow-[0_12px_25px_rgba(232,92,87,0.4)] transition-all" />
              </div>
            </div>

            {/* 2. KOLOM GAMBAR */}
            <div className="lg:col-span-5 relative w-full flex items-center justify-center h-[450px] sm:h-[550px] lg:h-[650px] mt-2 md:-mt-20 lg:mt-0">
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[300px] h-[300px] bg-sky-50/80 rounded-full blur-[80px] -z-10 pointer-events-none" />

              <div className="relative w-full h-full flex items-center justify-center">
                <div className="relative z-10 w-[280px] sm:w-[380px] lg:w-[480px] xl:w-[550px] h-[350px] sm:h-[450px] lg:h-[550px] xl:h-[650px]">
                  <Image
                    src="/images/cta/cta.png"
                    alt={t("LandingPage.hero_img_alt") || "Mockup Undangan Digital"}
                    fill
                    className="object-contain drop-shadow-2xl hover:scale-105 transition-transform duration-500"
                    priority
                  />
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      <PreviewTheme />
      <NewFeature />
      <FeatureTabs />
      <PackagePrice />
      <ComparisonTable />
      <NewFAQ />

    </main>
  );
}